/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SheepTileComponent.vue?vue&type=template&id=09fbac9b&scoped=true"
import script from "./SheepTileComponent.vue?vue&type=script&lang=js"
export * from "./SheepTileComponent.vue?vue&type=script&lang=js"
import style0 from "./SheepTileComponent.vue?vue&type=style&index=0&id=09fbac9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fbac9b",
  null
  
)

export default component.exports